import { allBlockchainCoin } from '@/assets/static/currency-list'

export default {
  getMyCasesVisibilityMenuSwitcher: (state) => state.myCasesVisibilityMenuSwitcher,
  getCasesActiveTab: (state) => state.casesActiveTab,
  getCasesTimeFilter: (state) => state.casesTimeFilter,
  getCasesLoading: (state) => state.casesLoading,
  getActiveBlockchain: state => state.activeBlockchain ?? allBlockchainCoin,
}